import * as Types from '../../@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateTestimonialTagSortOrderMutationVariables = Types.Exact<{
  tagIds: Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input'];
}>;


export type UpdateTestimonialTagSortOrderMutation = { __typename?: 'Mutation', updateTestimonialTagSortOrder: { __typename?: 'ResultResponse', count: number, error?: string | null } };


export const UpdateTestimonialTagSortOrderDocument = gql`
    mutation UpdateTestimonialTagSortOrder($tagIds: [Int!]!) {
  updateTestimonialTagSortOrder(tagIds: $tagIds) {
    count
    error
  }
}
    `;
export type UpdateTestimonialTagSortOrderMutationFn = Apollo.MutationFunction<UpdateTestimonialTagSortOrderMutation, UpdateTestimonialTagSortOrderMutationVariables>;

/**
 * __useUpdateTestimonialTagSortOrderMutation__
 *
 * To run a mutation, you first call `useUpdateTestimonialTagSortOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTestimonialTagSortOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTestimonialTagSortOrderMutation, { data, loading, error }] = useUpdateTestimonialTagSortOrderMutation({
 *   variables: {
 *      tagIds: // value for 'tagIds'
 *   },
 * });
 */
export function useUpdateTestimonialTagSortOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTestimonialTagSortOrderMutation, UpdateTestimonialTagSortOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTestimonialTagSortOrderMutation, UpdateTestimonialTagSortOrderMutationVariables>(UpdateTestimonialTagSortOrderDocument, options);
      }
export type UpdateTestimonialTagSortOrderMutationHookResult = ReturnType<typeof useUpdateTestimonialTagSortOrderMutation>;
export type UpdateTestimonialTagSortOrderMutationResult = Apollo.MutationResult<UpdateTestimonialTagSortOrderMutation>;
export type UpdateTestimonialTagSortOrderMutationOptions = Apollo.BaseMutationOptions<UpdateTestimonialTagSortOrderMutation, UpdateTestimonialTagSortOrderMutationVariables>;